import { differenceInMinutes, parseISO, getTime } from 'date-fns'

function allCoaches() {
  return [
    { id: 'espen_jorstad', format: 'mtt', img: 'espen_jorstad.webp' },
    { id: 'stoyan_obreshkov', format: 'mtt', img: 'stoyan.webp' },
    { id: 'thewakko', format: 'cash', img: 'the_wakko.webp' },
    { id: 'poker_giraffe', format: 'theory', img: 'poker_giraffe.webp' },
    { id: 'donk_orleone', i18n_key_bio: 'bio_tra01', format: 'cash', img: 'donk_orleone.webp' },
    { id: 'saulo_costa', format: 'cash', img: 'saulo_costa.webp' },
    { id: 'mathias_maasberg', format: 'mtt', img: 'mathias.webp' },
    { id: 'tombos', format: 'theory', img: 'tombos21.webp' },
    { id: 'beldarion', format: 'spins', img: 'beldarion.webp' },
    { id: 'sido', format: 'spins', img: 'sido.webp' },
    { id: 'matt_hunt', format: 'mtt', img: 'matt_hunt.webp' },
    { id: 'manuel_phemo', format: 'mtt', img: 'manuel_phemo.webp' },
    { id: 'yolan_cohen', format: 'cash', img: 'yolan_cohen.webp' },
    { id: 'kevin_rabichow', format: 'mtt', img: 'kevin_rabichow.webp' },
    { id: 'sergii_levchenko', format: 'cash', img: 'sergii_levchenko.webp' },
    { id: 'vanja', format: 'cash', img: 'vanja.webp' },
  ]
}

function formatISODate({
  date,
  opts = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: false,
    minute: false,
    second: false,
    timeZoneName: null,
  },
  locale = 'en',
}) {
  if (date) {
    const parsed = parseISO(date)
    const options = {
      year: opts.year,
      month: opts.month,
      day: opts.day,
      hour12: false,
      ...(opts?.hour ? { hour: '2-digit' } : {}),
      ...(opts?.minute ? { minute: '2-digit' } : {}),
      ...(opts?.second ? { second: '2-digit' } : {}),
      ...(opts?.timeZoneName ? { timeZoneName: opts?.timeZoneName } : {}),
    }
    const localeStr = parsed.toLocaleDateString(locale, options)

    return localeStr
  }
  return ''
}

function getCoachingItemStatus({ item }) {
  const date = parseISO(item.datetime)
  const l_dateNow = new Date()
  const minutes = differenceInMinutes(date, l_dateNow)
  const res = {
    // coaching_in_progress: minutes <= 62 && minutes > -60,
    coaching_in_progress: minutes <= 10 && minutes > -60,
    past_event: minutes < -60,
    todays_event: minutes <= 1440 && minutes > -60,
    // future_event: minutes > -60,
    minutes,
  }
  // console.log(minutes)
  return res
}

function getMappedCoachingItem({ item, locale }) {
  const datetime_cest = item.datetime
  const status = getCoachingItemStatus({ item })

  const provider = item.provider.toLowerCase()
  const { preview_video_id } = item
  const source_id = item.available_to_user ? item.video_id : preview_video_id

  const res = {
    id: item.id,
    is_watched: item.is_watched,
    is_favorite: item.is_favorite,
    name: item.name,
    coach_name: item.coach.name,
    coach_id: item.coach.custom_id,
    coach_api_id: item.coach.id,
    description: item.description,
    datetime: getTime(parseISO(item.datetime)),
    datetime_cest,
    datetime_locale: formatISODate({ date: datetime_cest, locale }),
    format: item.format.toLowerCase(),
    live_link: item.live_link,
    provider,

    video_id: item.video_id,
    preview_video_id,
    source_id,

    preview: item.video_id ? false : !!preview_video_id,

    is_past: status.past_event,
    in_post_production: status.past_event && !item.video_id && !preview_video_id,
    is_today: status.todays_event || status.coaching_in_progress,
    in_progress: status.coaching_in_progress,
    available_to_user: item.available_to_user,
    status,
    item,
  }

  // console.log(item, res)
  return res
}

export { getMappedCoachingItem, allCoaches }
